"use client";
import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material";

export default function LoaderComponent({ open }) {
  const theme = useTheme();

  return (
    <div>
      <Backdrop
        sx={{
          color: theme.palette.primary.main,
          zIndex: 3000,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
